import React from 'react';
import MenuItem from '@mui/material/MenuItem';
import TextField from '@mui/material/TextField';
import { useT } from '../../../i18n';

interface Option {
  id: number | string;
  name: string;
}

interface OfficeRouteSelectsProps {
  offices: Option[];
  officeId: string | number | null | undefined;
  onOfficeChange: (officeId: string) => void;
  /** Sin `routes` solo se muestra la sede. */
  routes?: Option[];
  routeId?: string | number | null;
  onRouteChange?: (routeId: string) => void;
  /** Opción al inicio de la lista de rutas (por ejemplo, "Todas"). */
  routeAllOption?: { value: string; label: string };
  routeDisabled?: boolean;
  required?: boolean;
  /** Marca para el recorrido de la pantalla: `data-tour` `<prefijo>-office` y `<prefijo>-route`. */
  tourPrefix?: string;
}

/** Sede y ruta como dos campos de filtro (van dentro de la rejilla de filtros de la página). */
const OfficeRouteSelects: React.FC<OfficeRouteSelectsProps> = ({
  offices,
  officeId,
  onOfficeChange,
  routes,
  routeId,
  onRouteChange,
  routeAllOption,
  routeDisabled,
  required,
  tourPrefix,
}) => {
  const t = useT();
  return (
    <>
      <TextField
        select
        size="small"
        fullWidth
        required={required}
        label={t('common.office')}
        data-tour={tourPrefix ? `${tourPrefix}-office` : undefined}
        value={officeId == null ? '' : String(officeId)}
        onChange={(e) => onOfficeChange(e.target.value)}
      >
        {offices.map((office) => (
          <MenuItem key={office.id} value={String(office.id)}>
            {office.name}
          </MenuItem>
        ))}
      </TextField>
      {routes && onRouteChange ? (
        <TextField
          select
          size="small"
          fullWidth
          required={required}
          disabled={routeDisabled}
          label={t('common.route')}
          data-tour={tourPrefix ? `${tourPrefix}-route` : undefined}
          value={routeId == null ? '' : String(routeId)}
          onChange={(e) => onRouteChange(e.target.value)}
        >
          {routeAllOption ? <MenuItem value={routeAllOption.value}>{routeAllOption.label}</MenuItem> : null}
          {routes.map((route) => (
            <MenuItem key={route.id} value={String(route.id)}>
              {route.name}
            </MenuItem>
          ))}
        </TextField>
      ) : null}
    </>
  );
};

export default OfficeRouteSelects;
